import { render, staticRenderFns } from "./searchbrand.vue?vue&type=template&id=78ec8400&scoped=true&"
import script from "./searchbrand.vue?vue&type=script&lang=js&"
export * from "./searchbrand.vue?vue&type=script&lang=js&"
import style0 from "./searchbrand.vue?vue&type=style&index=0&id=78ec8400&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ec8400",
  null
  
)

export default component.exports